// extracted by mini-css-extract-plugin
export default {"label":"TitleInfo_label__dY0wo","data":"TitleInfo_data__67xqs","chip":"TitleInfo_chip__4OCXu"};